import { jsx as o, jsxs as c } from "react/jsx-runtime";
import a from "react";
import { p } from "../../index-D-yg0idA.mjs";
function d({ sections: t = [] }) {
  const r = /* @__PURE__ */ new Map([
    ["primary", {
      open: '<h1 class="h2">',
      close: "</h1>"
    }],
    ["secondary", {
      open: '<h2 class="h3">',
      close: "</h2>"
    }]
  ]);
  return /* @__PURE__ */ o("sectioned-content", { children: t.length && t.map((e, n) => e.content !== "" ? /* @__PURE__ */ c(a.Fragment, { children: [
    p(r.get(e.header.type).open + e.header.title + r.get(e.header.type).close),
    typeof e.content == "string" ? p(e.content) : e.content
  ] }, `section-${e.title}-${n}`) : /* @__PURE__ */ o(a.Fragment, {}, `section--${n}`)) });
}
export {
  d as SectionedContent,
  d as default
};
